/**
 * `profile.links` as the backend really sends it: an array holding one object
 * (`[{ website, discord, telegram, instagram }]` — what the save sends), `[[]]`
 * when nothing is set, and on older rows a JSON string of either. Read as the
 * one object, or `{}`. Parsing it as a string only (what this did before) threw
 * on every real profile, showed the links empty, and saved them back empty.
 */
export function readProfileLinks(raw: unknown): Record<string, string> {
  let value: unknown = raw
  if (typeof value === "string") {
    try {
      value = JSON.parse(value)
    } catch {
      return {}
    }
  }
  if (Array.isArray(value)) value = value[0]
  if (!value || typeof value !== "object" || Array.isArray(value)) return {}
  const out: Record<string, string> = {}
  for (const [k, v] of Object.entries(value as Record<string, unknown>)) if (typeof v === "string") out[k] = v
  return out
}
